import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { devConfig } from 'config/config'; // Importing development configuration from the config module

/**
 * Class representing a view for displaying products in a third-party betting shop.
 * @extends JetView
 */
export default class tableProductsThirdByBetShopView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format based on the application configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define the main view as a datatable
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatable',
            // CSS classes for styling the datatable borders
            css: 'webix_header_border webix_data_border webix_footer_border',
            // Enable row selection
            select: true,
            // Set height based on screen width
            height: screen.width < 500 ? 400 : 0,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for editing with an icon
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip for the edit icon
                    tooltip: _('Editar'),
                    // Template function to render the edit icon
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close edit'></span>";
                    },
                },
                // Column for displaying the ID
                { id: 'Id', header: 'ID', width: 100, sort: 'int' },
                {
                    // Column for displaying third-party products
                    id: 'ProductsThird',
                    header: _('Producto Terceros'),
                    width: 250,
                    sort: 'int',
                },
                {
                    // Column for displaying activation status
                    id: 'IsActivate',
                    header: _('Estado'),
                    editor: 'combo', // Enable combo editor for this column
                    options: [
                        { id: 'A', value: _('Activado') }, // Active option
                        { id: 'I', value: _('Inactivado') }, // Inactive option
                    ],
                    width: 100,
                    sort: 'int',
                },
            ],
            // Define click event handlers
            onClick: {
                // Show edit dialog on clicking the edit icon
                edit: function (euv, id) {
                    $$('EditProductsThirdByBetShop').show();
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching strategy
            loadahead: devConfig.getDefaultDataFetch(),
            // Define the pager for pagination
            pager: 'pagerA',
            // Set the URL for fetching data from the API
            url: devConfig.geturlApi() + 'BetShop/GetProductsThird?FromId=' + cur_user + '&',
            // Initial data for the datatable
            data: [
                {
                    Id: '01', // ID of the first product
                    ProductsThird: 'Producto 1', // Name of the first product
                    IsActivate: 'A', // Activation status of the first product
                },
                {
                    Id: '02', // ID of the second product
                    ProductsThird: 'Producto 2', // Name of the second product
                    IsActivate: 'I', // Activation status of the second product
                },
            ],
            // Define event handlers for the datatable
            on: {
                // Show edit dialog on double-clicking an item
                onItemDblClick: (id) => {
                    $$('EditProductsThirdByBetShop').show();
                },
            },
        }; // Placeholder for the configuration content of the view
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Get the URL for the grid data
        var url = grid.data.url;
        // Initialize an empty filter string
        var filter = '';
        // Get the current user parameter, required
        const cur_user = this.getParam('user', true);
        // Initialize an array for date popup data
        var datePopup = [];
        // Initialize a variable for the popup window
        var popupAdd = '';
        // Perform an AJAX request to fetch products for the third select
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set the content type for the request
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetProductsThirdSelect', // API endpoint
                '', // No request body
                {
                    // Handle error response
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Display error message
                    },
                    // Handle successful response
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse the JSON response
                        datePopup = resp.Data; // Store the data for the date popup
                        // Create a new popup window for adding products
                        popupAdd = webix.ui({
                            view: 'window',
                            id: 'AddProductsThird', // Unique identifier for the window
                            head: {
                                view: 'toolbar',
                                cols: [
                                    { view: 'label', label: _('Añadir') }, // Label for the window
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close', // Close icon
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window on click
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center the window on the screen
                            modal: true, // Make the window modal
                            body: {
                                view: 'form',
                                id: 'addform', // Unique identifier for the form
                                elements: [
                                    {
                                        view: 'combo',
                                        label: _('Producto Tercero'), // Label for the combo box
                                        name: 'ProductsThird', // Name of the field
                                        options: datePopup, // Options for the combo box
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Estado'), // Label for the status combo box
                                        name: 'IsActivate', // Name of the field
                                        options: [
                                            { id: 'A', value: _('Activado') }, // Active option
                                            { id: 'I', value: _('Inactivado') }, // Inactive option
                                        ],
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'button',
                                                value: _('Cancelar'), // Cancel button label
                                                click: function () {
                                                    this.getTopParentView().hide(); // Hide the window on cancel
                                                    $$('addform').setValues(
                                                        // Reset the form values
                                                        $$('addform').getCleanValues(),
                                                    );
                                                },
                                            },
                                            {
                                                view: 'button',
                                                type: 'form', // Button type for form submission
                                                value: _('Guardar'), // Save button label
                                                click: function ($e) {
                                                    var values = $$('addform').getValues(); // Get form values
                                                    // Perform an AJAX request to save the product
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'BetShop/ProductsThird', // API endpoint for saving
                                                            '{"ProductsThird":"' +
                                                                values.ProductsThird +
                                                                '", "BetShop":"' +
                                                                cur_user +
                                                                '", "IsActivate":"' +
                                                                values.IsActivate +
                                                                '"}', // Request body with product data
                                                            {
                                                                // Handle error response
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        _('Error! '), // Display error message
                                                                    );
                                                                },
                                                                // Handle successful response
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        _(
                                                                            'Agregado', // Display success message
                                                                        ),
                                                                    );
                                                                    grid.clearAll(); // Clear the grid data
                                                                    grid.load(
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reload the grid with updated data
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    $$('addform').setValues(
                                                        // Reset the form values after submission
                                                        $$('addform').getCleanValues(),
                                                    );
                                                    this.getTopParentView().hide(); // Hide the window after saving
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        });
                    },
                },
            );
        // Create a popup window for editing products
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'EditProductsThirdByBetShop', // Unique identifier for the window
            head: {
                // Header section of the window
                view: 'toolbar', // Toolbar view for the header
                cols: [
                    // Columns in the toolbar
                    { view: 'label', label: _('Editar') }, // Label for editing
                    {
                        view: 'icon', // Icon button to close the window
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to hide the window
                            this.getTopParentView().hide(); // Hide the top parent view (the window)
                        },
                    },
                ],
            },
            position: 'center', // Position the window in the center of the screen
            modal: true, // Make the window modal
            body: {
                // Body section of the window
                view: 'form', // Define the body as a form
                id: 'editForm', // Unique identifier for the form
                elements: [
                    // Form elements
                    { view: 'text', label: 'ID', name: 'Id', readonly: true }, // Read-only text field for ID
                    {
                        view: 'combo', // Combo box for selecting a third product
                        label: _('Producto Tercero'), // Label for the combo box
                        name: 'ProductsThird', // Name of the field
                        readonly: true, // Make the combo box read-only
                    },
                    {
                        view: 'combo', // Combo box for selecting the status
                        label: _('Estado'), // Label for the combo box
                        name: 'IsActivate', // Name of the field
                        options: [
                            // Options for the combo box
                            { id: 'A', value: _('Activado') }, // Option for activated status
                            { id: 'I', value: _('Inactivado') }, // Option for deactivated status
                        ],
                    },
                    {
                        cols: [
                            // Columns for buttons
                            {
                                view: 'button', // Button for cancel action
                                value: _('Cancelar'), // Button label
                                click: function () {
                                    // Click event for the button
                                    this.getTopParentView().hide(); // Hide the window
                                    $$('editForm').setValues(
                                        // Reset form values
                                        $$('editForm').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Button for save action
                                type: 'form', // Button type indicating form submission
                                value: _('Guardar'), // Button label
                                click: function ($e) {
                                    // Click event for the button
                                    var values = $$('editForm').getValues(); // Get form values
                                    webix // Perform an AJAX request
                                        .ajax()
                                        .headers({
                                            // Set request headers
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            // Send a POST request
                                            devConfig.geturlApi() + // API URL
                                                'BetShop/ProductsThird',
                                            '{"Id":"' + // Request body in JSON format
                                                values.Id +
                                                '", "ProductsThird":"' +
                                                values.ProductsThird +
                                                '", "BetShop":"' +
                                                cur_user +
                                                '", "IsActivate":"' +
                                                values.IsActivate +
                                                '"}',
                                            {
                                                error: function (
                                                    // Error callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (
                                                    // Success callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message(_('Actualizado')); // Show success message
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        // Reload the grid with updated data
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                    );
                                                },
                                            },
                                        );
                                    $$('editForm').setValues(
                                        // Reset form values
                                        $$('editForm').getCleanValues(),
                                    );
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Bind the edit form to the data table for synchronization
        $$('editForm').bind($$('datatable'));

        // Listen for the 'productsThird:filter' event and handle filtering logic
        this.on(this.app, 'productsThird:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize query string for filters

            // Iterate over each entry in the filter data
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and is not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle 'CreatedLocalDate' filter
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        // Handle 'ModifiedLocalDate' filter
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to query
                            string1 = string1 + '&dateTo2=' + date[1]; // Add end date to query
                        } else {
                            // Add other filters to query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // Handle case where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        // Iterate over each entry in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' date in the nested object
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' + // Format year
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' + // Format month
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' + // Format day
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' + // Format hours
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' + // Format minutes
                                        ('00' + d.getSeconds()).slice(-2); // Format seconds
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    // Handle 'end' date in the nested object
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' + // Format year
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' + // Format month
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' + // Format day
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' + // Format hours
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' + // Format minutes
                                            ('00' + d.getSeconds()).slice(-2); // Format seconds
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Clear existing grid data
            grid.clearAll();
            // Load new data into the grid with the constructed query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the current filter string
        });
        // Attach an event listener for the 'onAfterSort' event on the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters and pagination
            grid.load(
                url + // Base URL for loading data
                    '?start=0&count=' + // Pagination parameters
                    grid.data.$pagesize + // Current page size from grid data
                    filter + // Additional filter parameters
                    '&sort[' + // Sort parameters
                    by + // Column to sort by
                    ']=' +
                    dir, // Direction of sorting (ascending or descending)
            );
        });

        // Listen for the 'addProductsThird:button' event on the application context
        this.on(this.app, 'addProductsThird:button', (filter) => {
            // Show the popup for adding products
            popupAdd.show();
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
